<template>
  <div class="delivery">
    <span>{{ data.goodsLogistics.deliveryTime }}</span>
  </div>
</template>
<script>
export default {
  name: "NewHtmlPart",
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.delivery {
  line-height: 30px;
  margin-left: 42px;
  margin-bottom: 10px;
  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }
  img.pre-tag {
    width: 36px;
    height: 20px;
  }
  span {
    font-size: 14px;
    color: #666;
  }
}
</style>
